<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jwKlbx/tc-custom/9780253011534.jpg?1705605802795" alt="This image is the cover for the book Beethoven Sonatas and the Creative Experience"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beethoven Sonatas and the Creative Experience
      </h1>
      <p class="bookDescription body article font2">
        <b>The definitive study of Beethoven’s piano sonatas is “remarkable as an insider’s account of the works in an individual perspective.” (<i>European Music Teacher</i>)</b><br/>  <br/> In “one of the most interesting, useful and even exciting books on the process of musical creation” (<i>American Music Teacher</i>), Kenneth O. Drake groups the Beethoven piano sonatas according to their musical qualities, rather than their chronology. He explores the interpretive implications of rhythm, dynamics, slurs, harmonic effects, and melodic development and identifies specific measures where Beethoven skillfully employs these compositional devices.<br/>  <br/> An interpreter searching for meaning, Drake begins with Beethoven’s expressive treatment of the keyboard—the variations of touch, articulation, line, color, use of silence, and the pacing of musical ideas. He then analyzes individual sonatas, exploring motivic development, philosophic overtones, and technical demands. Hundreds of musical examples illustrate this exploration of emotional and interpretive implications of “the 32.” Here musicians are encouraged to exercise intuition and independence of thought, complementing their performance skills with logical conclusions about ideas and relationships within the score.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth Drake
      </h2>
      
      <p class="authorDescription body article">Kenneth Drake is Professor Emeritus of Piano at the University of Illinois and author ofThe Sonatas of Beethoven as He Played and Taught Them. He is active as a performer on period pianos.Cover illustration: The Beethoven Broadwood fortepiano. Courtesy of the Hungarian National Museum. Photo by Sheila Rock, Thorn EMI London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?271f0874